import React from 'react'
import RupayUpiApprove from '../../myapp/fund/rupayUPIApprove'

function RupayUpiApprovePage() {
  return (
    <RupayUpiApprove/>
  )
}

export default RupayUpiApprovePage
